export type OperationState = {
  operationState: 'edit-success' | 'add-success';
};

export const replaceState = () => {
  window.history.replaceState({state: ''}, '');
};
